export default __webpack_public_path__ + "static/media/13.877becc2.jpg";